import React from 'react'
import { useParams } from 'react-router-dom'
import { useFetch } from 'use-http'

import { Box, Heading, Stack, Text } from '@myxplor/stardust'

import LoadingLoop from '~/src/components/LoadingLoop'

import { ServiceDetail } from './types'
import ContactEmail from './ContactEmail'
import Features from './Features'
import Plans from './Plans'
import TabletLogin from './TabletLogin'

const ServiceView = () => {
  const { serviceId } = useParams()

  const serviceRequest = useFetch(`/api/v1/services/${serviceId}`, {}, [])

  if (serviceRequest.loading) {
    return <LoadingLoop />
  }

  if (serviceRequest.error) {
    return <div>Error...</div>
  }

  const service = serviceRequest.data.data as ServiceDetail

  return (
    <Stack space="small">
      <Box alignItems="center" display="flex" justifyContent="space-between" width={1}>
        <Heading level={4}>{service.name}</Heading>
      </Box>
      <Box display="flex">
        <Box display="flex" flexDirection="column" paddingRight="medium">
          <Text prefab="overline">BMS</Text>
          <Text lineHeight={1.4} prefab="body">
            {service.vendor.name}
          </Text>
        </Box>
        <Box display="flex" flexDirection="column" paddingRight="medium">
          <Text prefab="overline">Account</Text>
          <Text lineHeight={1.4} prefab="body">
            {service.account.name}
          </Text>
        </Box>
        <Box display="flex" flexDirection="column" paddingRight="medium">
          <Text prefab="overline">Native ID</Text>
          <Text lineHeight={1.4} prefab="body">
            {service.origin_id}
          </Text>
        </Box>
      </Box>
      <ContactEmail service={service} onRefreshServiceData={() => serviceRequest.get()} />
      <Plans service={service} onRefreshServiceData={() => serviceRequest.get()} />
      <Features service={service} />
      {service.playground_enabled && <TabletLogin service={service} />}
    </Stack>
  )
}

export default React.memo(ServiceView)
